// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1XmEE","item":"PaymentsMobile_item__3RNCA","label":"PaymentsMobile_label__2LruP","amount":"PaymentsMobile_amount__3WpRJ"};